// DEV Test server
export const environment = {
  production: true,
  dataApiBaseUrl:"https://test.shop.oov2.mojosoft.work/ws",
  javaApiBaseUrl : "https://test.shop.oov2.mojosoft.work/javaws",
};

